module.exports = require("./timezones.json");
